import { render } from "./AppTextArea.vue?vue&type=template&id=2504fa41"
import script from "./AppTextArea.vue?vue&type=script&lang=js"
export * from "./AppTextArea.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__